import axiosInstance from './axiosInstance';
import { API_ROUTES } from './constants';

// Create a new product
export const createProduct = async (productData) => {
  try {
    const response = await axiosInstance.post(API_ROUTES.PRODUCTS.CREATE, productData);
    return response.data;
  } catch (error) {
    console.error('Error creating product:', error);
    throw error;
  }
};

// Update an existing product
export const updateProduct = async (productId, updateData) => {
  try {
    const response = await axiosInstance.patch(`${API_ROUTES.PRODUCTS.UPDATE}/${productId}`, updateData);
    return response.data;
  } catch (error) {
    console.error('Error updating product:', error);
    throw error;
  }
};

// Get all products with optional query parameters
export const getProducts = async (queryParams = {}) => {
  try {
    const params = {
      page: queryParams?.page || 1,
      search: queryParams?.search || '',
      sortBy: queryParams?.sortBy || 'createdAt',
      category: queryParams.category || '',
      brand: queryParams.brand || '',
    };

    const response = await axiosInstance.get(API_ROUTES.PRODUCTS.GET, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching products:', error);
    throw error;
  }
};
export const getProductsWithDetail = async () => {
  try {

    const response = await axiosInstance.get(API_ROUTES.PRODUCTS.GET_ALL_WITH_DETAILS);
    return response.data;
  } catch (error) {
    console.error('Error fetching products:', error);
    throw error;
  }
};

export const getProductsWithTax = async () => {
  try {

    const response = await axiosInstance.get(API_ROUTES.PRODUCTS.GET_ALL_WITH_TAX);
    return response.data;
  } catch (error) {
    console.error('Error fetching products:', error);
    throw error;
  }
};

export const getProduct = async (productId) => {
  try {
    const response = await axiosInstance.get(`${API_ROUTES.PRODUCTS.GET_SINGLE_PRODUCT}/${productId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching product:', error);
    throw error;
  }
};

// Delete one or multiple products
export const deleteProducts = async (productIds) => {
  try {
    const response = await axiosInstance.delete(API_ROUTES.PRODUCTS.DELETE, {
      data: {
        ids: productIds // array of numbers, e.g., [1, 2, 3]
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting products:', error);
    throw error;
  }
};

export const getCategoryBrand = async () => {
  try {
    const response = await axiosInstance.get(API_ROUTES.PRODUCTS.GET_CATEGORY_BRAND);
    return response.data;
  } catch (error) {
    console.error('Error fetching product:', error);
    throw error;
  }
};

export const getAllProducts = async (queryParams = {}) => {
  try {
    const params = {
      isPopular: queryParams?.isPopular || false,
      latest: queryParams?.latest || false,
      isHotDeal: queryParams?.isHotDeal || false,
      isBuilderChoice: queryParams?.isBuilderChoice || false,
      isProPicks: queryParams?.isProPicks || false,
      isTrendingNow: queryParams?.isTrendingNow || false,
      mostOrdered: queryParams?.mostOrdered || false,
      productCount: queryParams?.productCount || 5,
    };

    const response = await axiosInstance.get(`${API_ROUTES.PRODUCTS.GET_ALL}`, { params });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAllProductsWithoutPagination = async () => {
  try {

    const response = await axiosInstance.get(API_ROUTES.PRODUCTS.GET_ALL_WITHOUT_PAGINATION);
    return response;
  } catch (error) {
    throw error;
  }
};

const productsApi = {
  createProduct,
  updateProduct,
  getProducts,
  deleteProducts,
  getAllProductsWithoutPagination
};

export default productsApi;